import { Modal as ModalModule } from 'common';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const PickupErrorModal = ({ modalId, data: { onClickLearnMore } }) => (
	<Modal
		modalId={modalId}
		className="history-pickup pickup-error-modal error-modal"
		header="Pickup Error"
		primaryButton={{
			text: 'Close',
			type: ModalButtonActionType.Ok,
			dataqa: 'pickup-error-close-button',
		}}
		secondaryButton={
			isFunction(onClickLearnMore)
				? {
						text: 'Learn More',
						type: ModalButtonActionType.Ok,
						onClick: onClickLearnMore,
						dataqa: 'pickup-error-learn-more-button',
					}
				: null
		}
		size="small"
	>
		<div className="error-modal-body">
			<p>No prints are eligible for pickup.</p>

			{isFunction(onClickLearnMore) ? (
				<p>To learn more about pickup eligibility rules, click Learn More.</p>
			) : (
				''
			)}
		</div>
	</Modal>
);

PickupErrorModal.propTypes = {
	data: PropTypes.shape({
		onClickLearnMore: PropTypes.func,
	}),
};

export default PickupErrorModal;
